import React, { useEffect, useState } from "react";
import "./Blogs.scss";
import { Link } from "react-router-dom";
import { Breadcrumb, Card, Skeleton } from "antd";
import parse from "html-react-parser";
import { useSelector } from "react-redux";
import { HomeOutlined } from "@ant-design/icons";

import { Helmet } from "react-helmet";
import Api from "../../network/ApiConfig";
export default function Blogs() {
  // const { currentLang } = useSelector((state) => state?.entities?.user);
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  // const [loadinSend, setloadinSend] =  useState(false)
  // setloadinSend(true)
  useEffect(() => {
    setisLoading(true);
    Api.get(`Blogs/GetAll?Page=0`)
      .then((res) => {
        setisLoading(false);
        setBlogs(res.data);
      })
      .catch((error) => {
        setisLoading(false);
        console.log(error.message);
      });
  }, []);
  const currentLang = "ar";
  // console.log(blogs);
  return (
    <div className="blogs-page-wrapper">
      <Helmet>
        <title>المدونات</title>
        {/* <meta name="description" content={t.ChauffeurDescription} /> */}
      </Helmet>
      <div className="container">
        <div className="header-first">
          <Breadcrumb separator=">">
            <Breadcrumb.Item>
              <Link to="/home">
                <HomeOutlined />
                <p className="link-name">الرئيسية</p>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item className="last-bread">المدونات</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="blogs_container">
          {isLoading &&
            [1, 2, 3, 4, 5, 6, 7, 8]?.map((s) => (
              <Card
                className="card_blogs"
                hoverable
                cover={<Skeleton.Image active />}
                key={s}
                loading
              >
                <h2 className="blogs_title">
                  {" "}
                  {currentLang === "en"
                    ? parse(blogs?.Title || "")
                    : parse(blogs?.TitleLT || "")}{" "}
                </h2>
                <div className="blog-desc">
                  {currentLang === "en"
                    ? parse(blogs?.Description || "")
                    : parse(blogs?.DescriptionLT || "")}
                </div>
              </Card>
            ))}
          {blogs?.model?.Data?.map((blogs) => (
            <Link to={`/blogs/${blogs.Id}`} key={blogs.Id}>
              <Card
                className="card_blogs"
                hoverable
                bordered
                cover={<img alt="example" src={blogs.Image} />}
              >
                <h2 className="blogs_title">
                  {" "}
                  {currentLang === "en"
                    ? parse(blogs?.Title || "")
                    : parse(blogs?.TitleLT || "")}{" "}
                </h2>
                <div className="blog-desc">
                  {currentLang === "en"
                    ? parse(blogs?.Description || "")
                    : parse(blogs?.DescriptionLT || "")}
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
